/** Whether the given workflow type can use IVR Assist (proxied calling). */
export function isIvrAssistSupported(_workflowType?: string | null): boolean {
  return false;

  /** Enable once conferencing handover is ready */
  // return !!workflowType && ['pbm', 'unifiedmedbv', 'transportation'].includes(workflowType);
}
